import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchExampleRequest, fetchExampleSuccess, fetchExampleFailure } from './exampleSlice';

// Simulate an API call function (replace this with your actual API call)
const fetchExampleApi = () =>
    new Promise((resolve) => setTimeout(() => resolve({ data: 'Example data' }), 1000));

// Define the saga function that performs the async operation
function* fetchExample() {
    try {
        const response = yield call(fetchExampleApi); // Call the API
        yield put(fetchExampleSuccess(response.data)); // Dispatch success action with data
    } catch (error) {
        yield put(fetchExampleFailure(error.toString())); // Dispatch failure action with error
    }
}

// Watcher saga: listens for `fetchExampleRequest` actions and runs `fetchExample`
export function* watchExampleSaga() {
    yield takeLatest(fetchExampleRequest, fetchExample);
}
